/**
 * 单位：克
 */
export const UNIT_GRAM = '克';
export type UNIT_GRAM = typeof UNIT_GRAM;
/**
 * 单位：袋
 */
export const UNIT_BAG = '袋';
export type UNIT_BAG = typeof UNIT_BAG;

/**
 * 单位枚举
 */
export type ENUM_UNIT = UNIT_GRAM | UNIT_BAG;



// WEBPACK FOOTER //
// ./src/constants/Unit.ts